import image from "../../assets/images/Auth/404 page.jpg";

const Pagenotfound = () => {
  return (
    <div
      style={{
        height: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={image}
        style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
        alt="404 Not Found"
      />
    </div>
  );
};

export default Pagenotfound;
